

import { useState, useCallback } from 'react';

// Construye la lista de servicios a consultar
const buildServiceList = () => {
    const entries = [
        {
            env: process.env.REACT_APP_DATA_API_PRO,
            label: 'API Producción',
        },
        {
            env: process.env.REACT_APP_DATA_AUTH_PRO,
            label: 'AUTH Producción',
        },
        {
            env: process.env.REACT_APP_DATA_API_DEV,
            label: 'API Desarrollo',
        },
        {
            env: process.env.REACT_APP_DATA_AUTH_DEV,
            label: 'AUTH Desarrollo',
        },
        {
            env: process.env.REACT_APP_MAIL_SERVICES,
            label: 'MAILS',
        },
    ];

    const providers = ['Azure', 'Ionos', 'Serveo'];

    const services = entries.flatMap(({ env, label }) => {
        if (!env) return [];

        return env.split(',').map((rawUrl, idx) => {
            const provider = providers[idx] || `Extra${idx}`;
            const baseUrl = rawUrl.trim();
            const fullUrl = baseUrl.endsWith('/is_up') ? baseUrl : `${baseUrl}/is_up`;

            return {
                id: `${provider}-${label}`,
                provider,
                label,
                url: fullUrl,
            };
        });
    });

    return services;
};



const useServiceStatuses = () => {
    const [statuses, setStatuses] = useState({});

    const checkAll = useCallback(async () => {
        const services = buildServiceList();

        const results = await Promise.all(
            services.map(async (svc) => {
                try {
                    const res = await fetch(svc.url, { method: 'GET' });
                    if (!res.ok) throw new Error('Non-200');
                    const data = await res.json();
                    return [svc.id, data?.msg === true];
                } catch {
                    return [svc.id, false];
                }
            })
        );

        setStatuses(Object.fromEntries(results));
    }, []);

    return { statuses, checkAll };
};

export default useServiceStatuses;
